const resources = {
    thanksMessage: 'Thanks for your feedback!',
    submit: 'Submit',
    close: 'close',
    errorMessage: 'Something went wrong. Please try again.'
};

export default function getResource(label) {
    return resources[label];
}
